// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ipad_layout":"ipad_layout-3JKya4yh","layout":"layout-3NyzsaId","headAd":"headAd-3Vr05uXR","section":"section-2ZJd2vEQ","bottomAd":"bottomAd-3ONvIpm6"};